import { Directive, Input } from '@angular/core';
import type { MatDialogRef } from '@angular/material/dialog';

export type AllowEmptyStringForVoid<T> = T extends void ? '' | void : T;

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[typedDialog]',
  standalone: false,
})
export class TypedDialogDirective<T, R> {
  @Input() typedDialog: MatDialogRef<T, R>;
  @Input() matDialogClose: NoInfer<AllowEmptyStringForVoid<R>>;
  // eslint-disable-next-line @angular-eslint/no-input-rename
  @Input('mat-dialog-close') dialogResult: NoInfer<AllowEmptyStringForVoid<R>>;
}
